<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('用户信息')" prop="userInfo">
                <a-input v-model="queryParam.userInfo" :maxLength="32"
                         :placeholder="$t('用户信息搜索提示')" allow-clear
                         @pressEnter="handleQuery"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('姓名')" prop="name">
                <a-input v-model="queryParam.name" :maxLength="32"
                         :placeholder="$t('通用.输入.请输入')+$t('姓名')" allow-clear
                         @pressEnter="handleQuery"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('电话')" prop="phone">
                <a-input v-model="queryParam.phone" :maxLength="20"
                         :placeholder="$t('通用.输入.请输入')+$t('电话')" allow-clear
                         @pressEnter="handleQuery"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('合作意向')" prop="cooperationType">
                <a-select :placeholder="$t('通用.输入.请选择')+$t('合作意向')"
                          v-model="queryParam.cooperationType" style="width: 100%" allow-clear>
                  <a-select-option v-for="(d, index) in this.customDict.CooperationTypeEnum" :key="index"
                                   :value="d.type">{{ d.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="'审核状态'" prop="auditStatus">
                <a-select :placeholder="$t('通用.输入.请选择')+'审核状态'"
                          v-model="queryParam.auditStatus" style="width: 100%" allow-clear>
                  <a-select-option v-for="(d, index) in this.customDict.AuditStatusEnum" :key="index"
                                   :value="d.type">{{ d.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 6 || 24" :sm="24">
              <span class="table-page-search-submitButtons"
                    :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search"/>{{ $t('通用.按钮.查询') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon
                  type="redo"/>{{ $t('通用.按钮.重置') }}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['partner:partner:remove']">
          <a-icon type="delete"/>{{ $t('通用.按钮.删除') }}
        </a-button>
        <a-button type="primary" @click="handleExport" v-hasPermi="['partner:partner:export']">
          <a-icon type="download"/>{{ $t('通用.按钮.导出') }}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"/>
      </div>
      <!-- 详情弹窗 -->
      <detail-form ref="detailForm"/>

      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="userInfo" slot-scope="text, record">
          {{ $t('昵称') }}：{{ record.nickName || '-' }} <br/>
          {{ $t('手机号') }}：{{ record.mobile || '-' }}
        </span>
        <span slot="cooperationType" slot-scope="text, record">
          {{ record.cooperationTypeName }}
        </span>
        <span slot="shopLocation" slot-scope="text, record">
          {{ record.shopLocation || '-' }}
        </span>
        <span slot="auditStatus" slot-scope="text, record">
          {{ record.auditStatusName }}
        </span>
        <span slot="auditTime" slot-scope="text, record">
          {{ record.auditTime ? parseTime(record.auditTime) : '-' }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['partner:partner:query']"/>
          <a @click="handleDetail(record)" v-hasPermi="['partner:partner:query']">
            <a-icon type="eye"/>{{ $t('通用.按钮.详情') }}
          </a>
          <a-divider type="vertical" v-hasPermi="['partner:partner:audit']"/>
          <a-popconfirm v-if="record.auditStatus === 0"
                        :title="$t('确认审核通过')" ok-text="确定" cancel-text="取消"
                        @confirm="handleAudit(record, 1)" v-hasPermi="['partner:partner:audit']">
            <a href="javascript:void(0)">{{ $t('审核通过') }}</a>
          </a-popconfirm>
          <a href="javascript:void(0)" v-if="record.auditStatus === 0"
             class="text-red margin-left-sm"
             @click="openRejectModal(record)" v-hasPermi="['partner:partner:audit']">
            {{ $t('审核拒绝') }}
          </a>
          <a-divider type="vertical" v-hasPermi="['partner:partner:remove']"/>
          <a @click="handleDelete(record)" v-hasPermi="['partner:partner:remove']">
            <a-icon type="delete"/>{{ $t('通用.按钮.删除') }}
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
      <!-- 审核拒绝弹窗 -->
      <a-modal :title="$t('审核拒绝')" :visible="rejectVisible" :confirm-loading="rejectLoading"
               @ok="handleReject" @cancel="rejectVisible = false">
        <a-form-model-item :label="$t('拒绝原因')" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
          <a-textarea v-model="rejectForm.auditRemark" :rows="4" :maxLength="200"
                      :placeholder="$t('通用.输入.请输入')+$t('拒绝原因')"/>
        </a-form-model-item>
      </a-modal>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pagePartner, delPartner, auditPartner } from '@/api/partner/partner'
import { mapGetters } from 'vuex'
import { tableMixin } from '@/store/table-mixin'
import DetailForm from './modules/DetailForm'

export default {
  name: 'Partner',
  components: { DetailForm },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo: {},
      selectedRowKeys: [],
      selectedRows: [],
      rejectVisible: false,
      rejectLoading: false,
      rejectForm: {
        id: null,
        auditStatus: 2,
        auditRemark: ''
      },
      advanced: false,
      single: true,
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      queryParam: {
        userInfo: undefined,
        name: undefined,
        phone: undefined,
        cooperationType: undefined,
        auditStatus: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('用户信息'),
          dataIndex: 'userInfo',
          scopedSlots: { customRender: 'userInfo' },
          width: 180,
          align: 'center'
        },
        {
          title: this.$t('姓名'),
          dataIndex: 'name',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('电话'),
          dataIndex: 'phone',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('微信号'),
          dataIndex: 'wechat',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('合作意向'),
          dataIndex: 'cooperationType',
          scopedSlots: { customRender: 'cooperationType' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('店铺位置'),
          dataIndex: 'shopLocation',
          with: 180,
          scopedSlots: { customRender: 'shopLocation' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '审核状态',
          dataIndex: 'auditStatus',
          scopedSlots: { customRender: 'auditStatus' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('审核人'),
          dataIndex: 'auditName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('审核时间'),
          dataIndex: 'auditTime',
          scopedSlots: { customRender: 'auditTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('创建时间'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('通用.文本.操作'),
          dataIndex: 'operation',
          width: '20%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  created () {
    this.getList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {},
  methods: {
    getTotal (total) {
      return this.$t('通用.文本.共') + total + this.$t('通用.文本.条')
    },
    getList () {
      this.loading = true
      const param = { ...this.queryParam }
      // userInfo 搜索框同时搜索昵称和手机号
      if (param.userInfo) {
        param.nickName = param.userInfo
        delete param.userInfo
      }
      pagePartner(param).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery () {
      this.queryParam = {
        userInfo: undefined,
        name: undefined,
        phone: undefined,
        cooperationType: undefined,
        auditStatus: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange (pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        this.queryParam.sortField = sorter.columnKey
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = ''
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids = []
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('通用.文本.确认删除所选中数据'),
        onOk () {
          let data = []
          that.ids.map(id => data.push({ 'id': id }))
          return delPartner(data).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success(that.$t('通用.文本.删除成功'), 3)
          })
        },
        onCancel () {
          that.ids = []
        }
      })
    },
    // 查看详情
    handleDetail (record) {
      this.$refs.detailForm.open(record)
    },
    // 审核通过
    handleAudit (record, status) {
      auditPartner({
        id: record.id,
        auditStatus: status
      }).then(response => {
        if (response.success) {
          this.$message.success(this.$t('通用.文本.操作成功'), 3)
          this.getList()
        } else {
          this.$message.error(response.msg || this.$t('通用.文本.操作失败'))
        }
      })
    },
    // 打开拒绝弹窗
    openRejectModal (record) {
      this.rejectForm = {
        id: record.id,
        auditStatus: 2,
        auditRemark: ''
      }
      this.rejectVisible = true
    },
    // 审核拒绝
    handleReject () {
      if (!this.rejectForm.auditRemark) {
        this.$message.warning(this.$t('通用.输入.请输入') + this.$t('拒绝原因'))
        return
      }
      this.rejectLoading = true
      auditPartner(this.rejectForm).then(response => {
        if (response.success) {
          this.$message.success(this.$t('通用.文本.操作成功'), 3)
          this.rejectVisible = false
          this.getList()
        } else {
          this.$message.error(response.msg || this.$t('通用.文本.操作失败'))
        }
      }).finally(() => {
        this.rejectLoading = false
      })
    },
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('通用.文本.是否确认导出'),
        content: this.$t('通用.文本.此操作将导出当前条件下所有数据而非选中数据'),
        onOk () {
          that.download('partner/partner/export',
            ...that.queryParam
            , `合伙人申请_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
